export default __webpack_public_path__ + "static/media/bg-online-privacy-notice.6ee4c4c4.png";